import { createSlice } from '@reduxjs/toolkit';

export const initState = {
    targetNums: [],
};

const { actions, reducer } = createSlice({
    name: 'sensorLog',
    initState,
    reducers: {
        setTargetNums: (state, action) => {
            state.targetNums = action.payload;
        },
        reset: (state, action) => {
            const initialState = { ...initState, ...action.payload };
            for (let key in initialState) {
                state[key] = initialState[key];
            }
        },
    },
});

export const { setTargetNums, reset } = actions;
export default reducer;
